import React from 'react';
import usePageMeta from '../hooks/usePageMeta';
import '../styles/Terms.css';

const TermsPage: React.FC = () => {
  usePageMeta({
    title: 'Terms & Refund Policy | Bulge Bracket',
    description:
      'Terms of service and refund policy for Bulge Bracket interview preparation services.',
    path: '/terms'
  });

  return (
    <section className="section terms">
      <div className="container terms-inner">
        <p className="section-eyebrow">Terms &amp; refunds</p>
        <h1 className="terms-title">The small print, kept small.</h1>

        <h2>What you are buying</h2>
        <p>
          Bulge Bracket sells interview-preparation services: CV screening and
          rework, 1-on-1 technical, case-study and behavioural tutoring sessions,
          and bundles of them. Sessions are delivered over Zoom by
          tutors currently employed in the industry. Payment is taken upfront via
          Stripe; tutor booking opens immediately after checkout.
        </p>

        <h2>Refunds</h2>
        <p>
          Unused services are fully refundable within 30 days of purchase. No
          forms, just email{' '}
          <a href="mailto:hello@bulgebracket.co">hello@bulgebracket.co</a> from
          the address you paid with. If your first session was not what you
          expected, tell us within 24 hours of it and we refund that session in
          full. Once a session has been delivered, or a CV rework returned, that
          part of the purchase is otherwise non-refundable; the unused remainder
          of any bundle stays refundable pro-rata within the same 30-day window.
          Sessions are valid for 60 days from purchase (six months for
          Unlimited); we extend for documented interview-timeline reasons.
        </p>

        <h2>Scheduling and cancellations</h2>
        <p>
          Sessions can be rescheduled free of charge up to 24 hours before the
          booked time using the link in your booking confirmation. Cancellations
          inside 24 hours, or no-shows, count as a delivered session. If a tutor
          has to cancel, you rebook at your convenience and the session is never
          forfeited.
        </p>

        <h2>Switching services or tracks</h2>
        <p>
          Before your first booking you can switch any purchase to a different
          service or track. If there is a price difference we invoice
          or refund it. Email us and it&apos;s done the same day.
        </p>

        <h2>Tutors and confidentiality</h2>
        <p>
          Tutors advise in a personal capacity and appear anonymously. Nothing in
          a session constitutes inside information, a referral guarantee, or an
          endorsement by any employer. We never share your materials outside the
          tutor team, and we ask the same discretion of you regarding tutors&apos;
          identities.
        </p>

        <h2>No outcome guarantees</h2>
        <p>
          We prepare you properly; hiring decisions belong to the firms. Nobody
          can sell you an offer, and we do not pretend to.
        </p>

        <h2>Contact</h2>
        <p>
          Bulge Bracket, London, United Kingdom ·{' '}
          <a href="mailto:hello@bulgebracket.co">hello@bulgebracket.co</a> ·
          +44 7466 152039
        </p>
      </div>
    </section>
  );
};

export default TermsPage;
